
import { applyMask } from "@/applyMask";
import { getThemeColor } from "@/branding";
import { computed, defineComponent, inject } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: String,
    mascara: String,
    tclass: String,
    // Fora de um FormValidated (ex.: telas de login), o campo funciona com v-model.
    modelValue: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const values = inject(FormValidatedValuesKey, {});
    const errors = inject(FormValidatedErrorsKey, {});

    const onUpdate = inject(FormValidatedUpdateKey);

    const aplicaMascara = (value: string) => {
      if (!props.mascara) {
        return value;
      }
      return applyMask(value, props.mascara);
    };

    const removeMascara = (value: string) => {
      if (!props.mascara) {
        return value;
      }

      const reNotMaskValidChars = new RegExp(
        "[^" +
          props.mascara
            .replace(/\$./g, "")
            .replace(/[^0-9AaSUL$#]/g, "")
            .replace(/[0-9#]/g, "9")
            .replace(/9+/g, "9")
            .replace(/[AaSUL]/g, "A")
            .replace(/A+/g, "A")
            .split("")
            .map((v) => (v == "9" ? "0-9" : v == "A" ? "A-Za-z" : ""))
            .join("") +
          "]",
        "g"
      );
      return value.replace(reNotMaskValidChars, "");
    };

    const usaVModel = computed(() => props.modelValue !== undefined);

    const onChange = (event: Event) => {
      const { value } = event.target as HTMLInputElement;

      if (usaVModel.value) {
        emit("update:modelValue", removeMascara(value));
        return;
      }

      typeof onUpdate === "function" && onUpdate({ [props.name]: removeMascara(value) });
    };

    return {
      onChange,
      theme: getThemeColor(),
      value: computed(() =>
        aplicaMascara(
          (usaVModel.value ? props.modelValue : values[props.name]) as string
        )
      ),
      error: computed(() => errors[props.name]),
    };
  },
});
